export const weaponCategories: { category: string; icon: null }[] = [
  {
    category: 'No Filter',
    icon: null,
  },
  {
    category: 'Sidearm',
    icon: null,
  },
  {
    category: 'SMG',
    icon: null,
  },
  {
    category: 'Shotgun',
    icon: null,
  },
  {
    category: 'Rifle',
    icon: null,
  },
  {
    category: 'Sniper',
    icon: null,
  },
  {
    category: 'Heavy',
    icon: null,
  },
  {
    category: 'Melee',
    icon: null,
  },
];
